import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import "./index.css";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import CustomTabPanel from "../../components/CustomTabPanel/index.jsx";
import Box from '@mui/material/Box';
import UserPanel from "./UserPanel.jsx";
import ProjectPanel from "./ProjectPanel.jsx";
import ModelPanel from "./ModelPanel.jsx";

function Admin(props) {
  const navigate = useNavigate();

  useEffect(() => {
    if (
      !props.user ||
      !props.user.id ||
      props.user.featureUsers[2].role !== "Admin"
    ) {
      navigate("/");
    }
  }, [props, navigate])

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const [value, setValue] = useState(0);

  const handleChange = (e, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
            <Tab label="Users" {...a11yProps(0)} />
            <Tab label="Projects" {...a11yProps(1)} />
            <Tab label="Models" {...a11yProps(2)} />
          </Tabs>
        </Box>
        <CustomTabPanel value={value} index={0}>
          <UserPanel />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <ProjectPanel />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
          <ModelPanel />
        </CustomTabPanel>
      </Box>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.main.user,
    role: state.m2d.role
  };
};

export default connect(mapStateToProps)(Admin);
